<template>
    <div class="electricity">
        <Title firstName="今日事件" lastName="TODAY'S EVENTS"/>
        <div class="echarts">
            <div class="etype">
                <div class="eview">
                    <div id="myChart"></div>
                </div>
                <div class="edata">
                    <div class="level">
                        <p>紧急</p>
                        <p>0</p>
                    </div>
                    <div class="level">
                        <p>隐患</p>
                        <p>0</p>
                    </div>
                    <div class="level">
                        <p>通知</p>
                        <p>0</p>
                    </div>
                </div>
            </div>
            <div class="econtent">
                <div class="emessage" v-for="item in eventsList" :key="item.id">
                    <div class="eloop"><img :src="item.src" alt="">{{item.eloop}}</div>
                    <div class="ename">{{item.ename}}</div>
                    <div class="etime">
                        {{item.etime}}
                        <img src="@/assets/img/position1.png" alt="" @click="getCurrent(item)" style="cursor: pointer;">
                    </div>
                </div>
                <div class="emessage" v-show="eventsList.length == 0">
                    <div class="noneEvent" v-show="eventsList.length == 0">暂无报警</div>
                </div>
                <div class="emessage" v-show="eventsList.length == 0">
                    
                </div>
                <div class="emessage" v-show="eventsList.length == 0">
                    
                </div>
                <div class="emessage" v-show="eventsList.length == 0">
                    
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { getTodayYesTime } from '../../utils/common/index'
const Title = () => import('../../components/title/Title')
export default {
    data(){
        return {
            eventsList:[
                // {
                //     id:1,
                //     src:require('@/assets/img/r.png'),
                //     eloop:'智能控制实验室-1#变压器',
                //     ename:'高温',
                //     etime:'12小时前',
                //     area:'智能控制实验室',
                //     level:3
                // },
                // {
                //     id:2,
                //     src:require('@/assets/img/y.png'),
                //     eloop:'智慧配电房-2AA1-微机综保',
                //     ename:'过电压跳闸',
                //     etime:'1天前',
                //     area:'智慧配电房',
                //     level:2

                // },
                // {
                //     id:3,
                //     src:require('@/assets/img/b.png'),
                //     eloop:'智慧配电房-1AA3-电源进线',
                //     ename:'电流过高',
                //     etime:'3天前',
                //     area:'智慧配电房',
                //     level:1

                // },
                // {
                //     id:4,
                //     src:require('@/assets/img/b.png'),
                //     eloop:'智能控制实验室-B2动力负荷-母线',
                //     ename:'温度过高',
                //     etime:'1周前',
                //     area:'智能控制实验室',
                //     level:1
                // },
            ],
            option:{
                animation:false,
                color:['#FF5555', '#F5AA00', '#0D94FF'],
                title: {
                    text: '\n0',
                    textStyle:{
                        fontSize:"20",
                        fontFamily:'zcoolqingkehuangyouti',
                        fontWeight:'400',
                        color:'#FFF'
                    },
                    left: 'center',
                    top:"center"
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        center: ['50%', '50%'], // 饼图的圆心坐标
                        radius: ['75%', '85%'],
                        avoidLabelOverlap: true,
                        hoverAnimation: false,
                        label: {
                            normal: { // normal 是图形在默认状态下的样式
                                show: true,
                                position: 'center',
                                color: 'rgba(230,243,253,0.7)',
                                fontSize: 14,
                                fontWeight: '400',
                                formatter: '总\n\n' // {b}:数据名； {c}：数据值； 
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { 
                                value: 1048,
                            },
                            { 
                                value: 1048,
                            },
                            { 
                                value: 1048,
                            },
                        ]
                    }
                ],
                grid: {  
                    left: 0 ,  
                    top:0, 
                    right:0,
                    bottom:0
                }  
            },
        }
    },
    components:{
        Title
    },
    mounted(){
        this.echartsInit()
        // this.alarmEvents()
    },
    methods:{
        echartsInit(){
            let chartDom = document.getElementById('myChart');
            let myChart = echarts.init(chartDom);
            myChart.setOption(this.option)

             //窗口缩放后重新调整图标尺寸
            window.onresize = function (){
                myChart.resize();
            }
        },
        getCurrent(value) {
            // this.$emit('showAlarmPosition', value)
            console.log('原来 是显示报警 的位置，新功能还没规划 ');
        },
        async alarmEvents(){
            let time = getTodayYesTime()
            console.log(time)
            let data ={
                start:time.today.replace(/-/g,'/'),
                end:time.today.replace(/-/g,'/'),
                projectId:this.$store.state.projectId
            }
            let res = await this.$http.alarmEvent(data)
            console.log(res);
        }
    }
}
</script>

<style lang="less" scoped>
    .electricity{
        height: 33.3vh;
        z-index: 1;
        width: 20vw;
        position: fixed;
        top: 68.1vh;
        right: 1vw;
        
        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .etype{
                height: 12vh;
                overflow: hidden;
                .eview{
                    float: left;
                    width: 7.8vw;
                    height: 100%;
                    position: relative;
                    #myChart{
                        width: 11vh;
                        height: 11vh;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50% ,-50%);
                    }
                }
                .edata{
                    float: left;
                    width: 12vw;
                    height: 100%;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                    text-align: center;
                    position: relative;
                    .level{
                        p:nth-child(1){
                            font-weight: 400;
                            color: #E6F3FD;
                            opacity: 0.7;
                            font-size: 14rem;
                            padding-bottom: 5rem;
                        }
                        p:nth-child(2){
                            padding-top: 5rem;
                            font-size: 20rem;
                            font-family: zcoolqingkehuangyouti;
                            font-weight: 400;
                            color: #FF5555;
                        }
                    }
                    .level:nth-child(2){
                        p:nth-child(2){
                            color: #F5AA00;
                        }
                    }
                    .level:nth-child(3){
                        p:nth-child(2){
                            color: #0D94FF;
                        }
                    }
                }

                .edata::before{
                    content: '';
                    width: 100%;
                    height: 1px;
                    background-color: rgba(255, 255, 255, 0.3);
                    position: absolute;
                    left: 0;
                    top: 6vh;
                }
                .edata::after{
                    content: '';
                    width: 1rem;
                    height: 1rem;
                    border: 1rem solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    background-color: rgba(255, 255, 255, 0.3);
                    position: absolute;
                    left: -2rem;
                    top:calc(6vh - 1rem) ;
                }
            }

            .econtent{
                height:12vh ;
                .emessage{
                    height: 3vh;
                    line-height: 2.95vh;
                    display: flex;
                    flex-direction: row;
                    
                    .eloop{
                        padding:0 7rem  0 11rem;
                        color: rgba(255, 255, 255, 0.7);
                        font-size: 14rem;
                        font-weight: 400;
                        font-family: Source Han Sans CN;
                        width: 11vw;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;

                        &>img{
                            width: 18rem;
                            height: 18rem;
                            vertical-align: -4rem;
                            margin-right:7rem ;
                        }
                    }
                    .ename{
                        width: 4.5vw;
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: #8CCCFF;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .etime{
                        // margin-left: 1vw;
                        width: 4vw;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.5);
                        text-align: right;
                        img{
                            margin-left: 7rem;
                            width: 14rem;
                            height: 16rem;
                            vertical-align: -3rem;
                        }
                    }

                    .noneEvent{
                        width: 100%;
                        font-size: 16rem ;
                        text-align: center;
                        color: #E6F3FD;
                    }
                }
                .emessage:nth-child(odd){
                    background-color: rgba(164,209,255, 0.2);
                }
                
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>